module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/招募配图.f32c4288.png";